<script>
    import Util from 'util/util'
    import { autoGrade } from './AutoGradingUtil'
    import WordCounter from 'views/components/wordCounter/WordCounter.svelte'

    const { model, givenAnswer } = $props()

    const safeGivenAnswer = $derived.by(() => {

        // For a task with HTML answers, apply render safely
        if (model.get('task_info_json').options?.formatted || model.get('task_info_json').options?.equationTools) {
            return Util.renderContentSafely(givenAnswer)
        }

        // For a task with plain text answers, escape potential HTML tags
        return Util.makeLinksClickable(Util.nl2br(_.escape(givenAnswer)))
    })
</script>

{#if model.get('grading_mode') === 'auto'}
    {@const result = autoGrade(model, givenAnswer)}

    <div class="auto-grade">
        <div class="text-answer" class:red={!result.isCorrect} class:green={result.isCorrect}>
            <!-- eslint-disable-next-line svelte/no-at-html-tags -->
            {@html safeGivenAnswer}
        </div>

        {#if result.hasSpellingErrors}
            <div class="spelling-error">{window.i18n.gettext('Spelling incorrect')}</div>
        {/if}
    </div>

{:else}
    <div class="html-answer">
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html safeGivenAnswer}
    </div>
{/if}

{#if model.get('task_info_json').options?.word_counter}
    <WordCounter textString={givenAnswer}></WordCounter>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.auto-grade {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.auto-grade .text-answer {
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid currentColor;
}
.auto-grade .text-answer.green {
  color: #21894d;
  background-color: rgba(63, 209, 125, 0.1);
}
.auto-grade .text-answer.red {
  color: #fb455b;
  background-color: rgba(252, 119, 135, 0.1);
}
.auto-grade .spelling-error {
  padding: 6px 12px;
  border: 1px solid hsl(40, 4%, 84%);
  border-radius: 24px;
  font-size: 14px;
}

.html-answer :global(table) :global(td) {
  padding: 2px 8px 2px 0;
  vertical-align: top;
}
.html-answer :global(table):global(.has-border) :global(td) {
  padding: 4px 8px;
  border: 1px solid hsl(40, 4%, 84%);
}</style>
